module.exports = __webpack_public_path__ + "static/media/RASA-Logo.08f19225.png";